require.config({
    baseUrl : (( typeof JSConst === 'object') ? JSConst.config.absRefPrefix : '/') + 'src/js'
});
require(['default/config'], function() {
    // @formatter:off
    require([
        'jquery',
        'mmc.libs.log',
        'mmc.libs.namespace',
        'mmc.libs.TrackingHelper',
        'backbone',
        'partials/models/FormModel',
        'partials/views/FormView',
        'partials/views/TermsView',
        'partials/views/ThxPageView',
        'partials/router/AppRouter',
		'partials/navToggle',
        'mmc.libs.documentDomain',
        'mmc.libs.iFrameResizer'
    ], function(
        $,
        log,
        namespace,
        TrackingHelper,
        Backbone,
        FormModel,
        FormView,
        TermsView,
        ThxPageView,
        AppRouter,
		navToggle
    ) {
    // @formatter:on

        var trackingHelper,
            formModel,
            formView,
            termsView,
            thxPageView,
            appRouter;

        /*
         * init trackinghelper
         */
        (function() {
            var pageName;
            try {
                pageName = parent.dataLayer[0].pageNameVirtual;
            } catch(e) {
                pageName = '';
            }
            var trackingHelperConfig = {
                clean : true,

                pageName : ((JSConst.config.tracking.gtm.pageName.length > 0) ? JSConst.config.tracking.gtm.pageName : pageName),
                trackingCategory : 'EBS Promo 2017',
                trackingAction : JSConst.config.tracking.gtm.action,

                // To deactivate tracking for a specific tracking-engine set the function : null
                trackingMethods : {
                    trackGAJS : null,
                    trackAnalyticsJS : null,
                    trackOmniture : null
                    //trackGenericGTM : null
                }
            };

            trackingHelper = new TrackingHelper(trackingHelperConfig);
        })();

        //@todo: move to better position

        $.urlParam = function(name){
            var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
            if (results==null){
                return null;
            }
            else{
                return results[1] || 0;
            }
        }

        function areElementsInViewport () {
            var inViewport = false;
            $.each([ 'scrolltoform', 'track-submission-scroll', 'track-newsletter-scroll' ], function( index, value ) {
                var el = document.getElementById(value);
                /*if (typeof jQuery === "function" && el instanceof jQuery) {
                    el = el[0];
                }*/
                var rect = el.getBoundingClientRect();
                if (
                    rect.top >= 0 &&
                    rect.left >= 0 &&
                    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
                ) {
                    inViewport = value;
                }
            });
            return inViewport;
        }

        var isTimeout = true;
        var trackingTimeout = setTimeout(function(){ console.log('tracked') }, 3000);
        var delay = true;

        function trackScrolling(elementIds) {
            var inViewport = areElementsInViewport();
            if (inViewport !== false && isTimeout === false) {
                isTimeout = true;
                var trackName = '';
                switch (inViewport) {
                    case 'scrolltoform':
                        trackName = '1-sweepstake'
                        break;
                    case 'track-submission-scroll':
                        trackName = '2-wingallery'
                        break;
                    case 'track-newsletter-scroll':
                        trackName = '3-newsletter'
                        break;
                }
                if (trackName !== '') {
                    trackingTimeout = setTimeout(function(){
                        trackingHelper.track({
                            type : 'trackNOPV',
                            name : trackName,
                            nonInteraction : true,
                            action : 'Scrolling'
                        });
                    }, 3000);
                }
                delay = false;
                setTimeout(function(){ delay = true; }, 500);
            } else if (isTimeout === true && delay === true) {
                isTimeout = false;
                if (trackingTimeout) {
                    clearTimeout(trackingTimeout);
                }
            }
        }

        $(document).ready(function() {
            var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

            if (iOS === true) {
                $('body').addClass('is-ios');
            }

            $(document).on('change', '#file-input',  function() {
                $(this).parents('form').submit();
            });

            $(document).on('click', '.teaser-item .share', function() {
                var parent = $(this).parents('.teaser-item');
                parent.find('.hideonshare').hide();
                parent.find('>:first-child').toggleClass('hide-pseudo');
                parent.find('.share-submission-wrapper').show();
            });

            $(document).on('click', '.share-submission-close', function() {
                var parent = $(this).parents('.teaser-item');
                parent.find('.hideonshare').show();
                parent.find('>:first-child').toggleClass('hide-pseudo');
                parent.find('.share-submission-wrapper').hide();
            });

            $(document).on('click', '.show-overlay', function(e) {
                if ($(e.target).hasClass('no-overlay')) {
                    e.stopPropagation();
                    return;
                }
                var video = $(this).prev();
                var player = video.find('.video-player-inline');
                video.removeClass('video-noverlay').addClass('video-overlay').fadeIn();
                player.removeClass('video-player-inline').addClass('video-player');
                video.find('video')[0].play();
            });

            $(document).on('click', '.close-overlay', function() {
                var video = $(this).parent();
                var player = $(this).next();
                video.find('.share-overlay').hide();
                video.find('video')[0].pause();
                video.removeClass('video-overlay').addClass('video-noverlay');
                player.removeClass('video-player').addClass('video-player-inline');
            });

            $(document).on('click', '.teaser-audio', function(e) {
                if ($(e.target).hasClass('no-overlay')) {
                    e.stopPropagation();
                    return;
                }
                var audio = $(this).find('audio')[0];
                if (audio.paused) {
                    audio.play();
                } else {
                    audio.pause();
                }
            });

            $(document).on('click', '.more-submissions > span.load-more', function() {
                $(this).parent().prev().find('.submission:visible:last').nextAll("*:lt(5)").slideDown();
                if ($(this).parent().prev().find('.submission:visible:last').next().length === 0) {
                    $(this).removeClass('load-more');
                    $(this).html('Keine weiteren Einsendungen vorhanden');
                }
            });

            $(document).on('click', '.toggle-terms', function(e) {
                e.preventDefault();
                if ($(this).hasClass('terms-close')) {
                    $('body').toggleClass('overflow-hidden');
                    $('.terms').fadeToggle('fast');
                    $('html, body').animate({
                        scrollTop: $('#scrolltoform').offset().top
                    }, 300);
                } else {
                    $("html, body").animate({ scrollTop: 0 }, 300);
                    setTimeout(function(){
                        $('body').toggleClass('overflow-hidden');
                        $('.terms').fadeToggle('fast');
                    }, 300);
                }
            });

            $(window).scroll(function() {
                trackScrolling();
            })

            $('#tv-spot video').on('play', function (e) {
                trackingHelper.track({
                    type : 'trackNOPV',
                    name : 'header-tvc-play',
                    nonInteraction : true,
                    action : 'Video'
                });
            });

            $('#tv-spot video').on('ended', function (e) {
                trackingHelper.track({
                    type : 'trackNOPV',
                    name : 'header-tvc-100-percent',
                    action : 'Video'
                });
            });

            $('.video-track video').on('play', function (e) {
                var parent = $(this).parent().attr('id');
                trackingHelper.track({
                    type : 'trackNOPV',
                    name : parent + '-play',
                    nonInteraction : true,
                    action : 'Video'
                });
            });

            $('.video-track video').on('ended', function (e) {
                var parent = $(this).parent();
                parent.next().show();
                trackingHelper.track({
                    type : 'trackNOPV',
                    name : parent.attr('id') + '-100-percent',
                    action : 'Video'
                });
            });

            $('.audio-track audio').on('play', function (e) {
                var parent = $(this).parent().attr('id');
                trackingHelper.track({
                    type : 'trackNOPV',
                    name : parent + '-play',
                    nonInteraction : true,
                    action : 'Audio'
                });
            });

            $('.audio-track audio').on('ended', function (e) {
                var parent = $(this).parent().attr('id');
                trackingHelper.track({
                    type : 'trackNOPV',
                    name : parent + '-100-percent',
                    action : 'Audio'
                });
            });

            if (iOS === false) {
                $('#tv-spot').find('video')[0].play();
            }

            var submission = $.urlParam('submission');
            if ($.isNumeric(submission)) {
                var target = $('#submission' + submission);
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 300, function () {
                    var child = target.find('.teaser-content');
                    child.addClass('teaser-highlight');
                    child.trigger("click");
                });

            }
        });

        /*
         * init backbone app
         */
        formModel = new FormModel({
            url : window.JSConst.config.absRefPrefix + 'participation/'
        });

        uploadTextFormModel = new FormModel({
            type: 'text',
            url : window.JSConst.config.absRefPrefix + 'file-upload/'
        });

        uploadAudioFormModel = new FormModel({
            type: 'audio',
            url : window.JSConst.config.absRefPrefix + 'file-upload/'
        });

        uploadVideoFormModel = new FormModel({
            type: 'video',
            url : window.JSConst.config.absRefPrefix + 'file-upload/'
        });

        formView = new FormView({
            name : 'form',
            templateString : $('.mmc-stdform .template--form').html(),
            model : formModel
        });

        uploadTextFormView = new FormView({
            name : 'text',
            templateString : $('.mmc-stdform .template--textform').html(),
            model : uploadTextFormModel
        });

        uploadAudioFormView = new FormView({
            name : 'audio',
            templateString : $('.mmc-stdform .template--audioform').html(),
            model : uploadAudioFormModel
        });

        uploadVideoFormView = new FormView({
            name : 'video',
            templateString : $('.mmc-stdform .template--videoform').html(),
            model : uploadVideoFormModel
        });

        formView.on('onSubmit', function($formWrap) {
            $('html, body').animate({
                scrollTop: $('#scrolltoform').offset().top
            }, 300);
        });
        formView.on('onBeforeSend', function($formWrap, sendFieldsObj) {
            // to prevent form submission (e.g. after custom validation) throw string (which will be shown as error message):
            // throw 'custom validation error message';
            //implement tracking here
            /*if (sendFieldsObj['newsletter'] === '1') {
                trackingHelper.track({
                    type : 'trackNOPV',
                    name : 'newsletter_checked'
                });
            }
            if (sendFieldsObj['club'] === '1') {
                trackingHelper.track({
                    type : 'trackNOPV',
                    name : 'club_checked'
                });
            }*/
        });
        formView.on('onSuccessSend', function(data) {
            $('#filename').val('');
        });

        uploadTextFormView.on('onSubmit', function($formWrap) {
            $('html, body').animate({
                scrollTop: $('#scrolltoform').offset().top
            }, 300);
        });
        uploadTextFormView.on('onBeforeSend', function($formWrap, sendFieldsObj) {
            var text = $('#upload-text').val();
            uploadTextFormView.hide();
            formView.render();
            $('.mmc-stdform').append(formView.$el);
            $('#upload-field').hide();
            $('#filename').val(text);
            trackingHelper.track({
                type : 'trackNOPV',
                name : 'form-page',
                action : 'Gewinnspiel'
            });
            trackingHelper.track({
                type : 'trackSubPageView',
                name : 'gewinnspielformular',
                action : 'Gewinnspiel'
            });
        });
        uploadTextFormView.on('onSuccessSend', function(data) {
        });

        uploadAudioFormView.on('onSubmit', function($formWrap) {
            $('html, body').animate({
                scrollTop: $('#scrolltoform').offset().top
            }, 300);
        });
        uploadAudioFormView.on('onBeforeSend', function($formWrap, sendFieldsObj) {
            var filename = $('#file-input').val().split('\\').pop();
            var filesize = $('#file-input')[0].files[0].size / Math.pow(1024, 2);
            uploadAudioFormView.hide();
            formView.render();
            $('.mmc-stdform').append(formView.$el);
            $('#filename').attr('value', '');
            $('#filename').attr('data-errormessage', 'Bitte warten Sie, bis das File vollständig hochgeladen wurde.');
            $('.filename').html(filename);
            $('.totalMb').html(filesize.toFixed(2));
            trackingHelper.track({
                type : 'trackNOPV',
                name : 'form-page',
                action : 'Gewinnspiel'
            });
            trackingHelper.track({
                type : 'trackSubPageView',
                name : 'gewinnspielformular',
                action : 'Gewinnspiel'
            });
        });
        uploadAudioFormView.on('onSuccessSend', function(data) {
            trackingHelper.track({
                type : 'trackNOPV',
                name : 'audio-ready',
                action : 'Upload'
            });
        });

        uploadVideoFormView.on('onSubmit', function($formWrap) {
            $('html, body').animate({
                scrollTop: $('#scrolltoform').offset().top
            }, 300);
        });
        uploadVideoFormView.on('onBeforeSend', function($formWrap, sendFieldsObj) {
            var filename = $('#file-input').val().split('\\').pop();
            var filesize = $('#file-input')[0].files[0].size / Math.pow(1024, 2);
            uploadVideoFormView.hide();
            formView.render();
            $('.mmc-stdform').append(formView.$el);
            $('#filename').attr('value', '');
            $('#filename').attr('data-errormessage', 'Bitte warten Sie, bis das File vollständig hochgeladen wurde.');
            $('.filename').html(filename);
            $('.totalMb').html(filesize.toFixed(2));
            trackingHelper.track({
                type : 'trackNOPV',
                name : 'form-page',
                action : 'Gewinnspiel'
            });
            trackingHelper.track({
                type : 'trackSubPageView',
                name : 'gewinnspielformular',
                action : 'Gewinnspiel'
            });
        });
        uploadVideoFormView.on('onSuccessSend', function(data) {
            trackingHelper.track({
                type : 'trackNOPV',
                name : 'video-ready',
                action : 'Upload'
            });
        });

        termsView = new TermsView({
            name : 'terms',
            templateString : $('.mmc-stdform .template--terms').html()
        });

        thxPageView = new ThxPageView({
            name : 'thanks',
            templateString : $('.mmc-stdform .template--thx-page').html()
        });

        thxPageView.on('show', function(){
            trackingHelper.track({
                type : 'trackNOPV',
                name : 'thanks-page',
                action : 'Gewinnspiel'
            });
            trackingHelper.track({
                type : 'pageview',
                name : 'danke',
                action : 'Gewinnspiel'
            });
        });

        appRouter = new AppRouter({
            defaultView : uploadTextFormView,
            views : [formView, uploadTextFormView, uploadAudioFormView, uploadVideoFormView, termsView, thxPageView]
        });

        /*
         * create namespace and expose objects
         */
        namespace('MMCLIBS');
        MMCLIBS.trackingHelper = trackingHelper;
        MMCLIBS.formModel = formModel;
        MMCLIBS.formView = formView;
        MMCLIBS.uploadTextFormView = uploadTextFormView;
        MMCLIBS.uploadAudioFormView = uploadAudioFormView;
        MMCLIBS.uploadVideoFormView = uploadVideoFormView;
        MMCLIBS.termsView = termsView;
        MMCLIBS.thxPageView = thxPageView;
        MMCLIBS.appRouter = appRouter;

        /*
         * start routing
         */
        Backbone.history.start();
		navToggle('#menu .navigationTitle', '#mainNav');
        $( window ).resize(function() {
            navToggle('#menu .navigationTitle', '#mainNav');
        });
    });
});

define("default/master", function(){});

